// Third-party
import React from 'react';

// Components
import { Button } from '@/views/components/buttons';
import { ContactPastille } from '@/views/components/misc';

// Hooks
import useThemeVersion from '@/hooks/useThemeVersion';

// Types
import Comparison from '@/types/comparison';

// Utils
import { formatMessage } from '@/utils/i18n';
import { getComparisonContactName } from '@/utils/comparison';

type Props = {
  comparison: Comparison;
  redirectToContactPage: () => void;
};

const ComparisonContactButton = ({ comparison, redirectToContactPage }: Props) => {
  const { isLightVersion } = useThemeVersion();
  if (comparison.contact === undefined) return null;
  return (
    <Button
      aria-label={formatMessage('Comparison.ClickToContact', { name: getComparisonContactName(comparison) })}
      className="contact-button"
      dark={!isLightVersion}
      role="link"
      onClick={redirectToContactPage}
    >
      <ContactPastille contact={comparison.contact} />
    </Button>
  );
};

export default ComparisonContactButton;
